var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 367,
    viewBox: "0 0 501 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468.872 1.48999H259.1C248.538 1.48999 239.988 10.0398 239.988 20.6013V365.259H487.983V20.6013C487.983 10.0398 479.433 1.48999 468.872 1.48999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.791 28.6138L333.331 31.3481H337.688L334.404 34.5404H335.94L332.39 37.9897L332.381 37.9984L331.973 40.4676H340.582L341.041 37.7326H336.807L340.075 34.5404H338.539L342.091 31.0701L342.096 31.0651L342.505 28.6138H333.791Z",
    fill: "#FF5D0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M349.906 32.6097C349.201 31.9566 348.22 31.6309 346.964 31.6309C345.91 31.6309 344.986 31.8509 344.191 32.2915C343.397 32.7333 342.785 33.3469 342.352 34.1354C341.919 34.9239 341.703 35.8465 341.703 36.9044C341.703 38.0803 342.079 39.0035 342.832 39.6734C343.584 40.3444 344.624 40.6794 345.952 40.6794C347.836 40.6794 349.27 40.0435 350.253 38.7743L347.871 37.6799C347.67 37.856 347.447 38.0068 347.205 38.1298C346.962 38.2533 346.656 38.3151 346.289 38.3151C345.721 38.3151 345.288 38.1742 344.992 37.8912C344.78 37.6898 344.647 37.4247 344.586 37.0978H350.715C350.797 36.7919 350.86 36.4891 350.901 36.1894C350.942 35.8897 350.963 35.5931 350.963 35.2984C350.963 34.1589 350.611 33.2617 349.906 32.6091V32.6097ZM344.856 35.0877C345.025 34.7268 345.254 34.4438 345.543 34.2411C345.863 34.018 346.242 33.9062 346.68 33.9062C347.084 33.9062 347.397 34.0026 347.623 34.1966C347.848 34.3906 347.993 34.6495 348.058 34.9733C348.066 35.0104 348.069 35.0493 348.076 35.0877H344.857H344.856Z",
    fill: "#FF5D0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360.786 33.8648C360.626 33.3772 360.373 32.9582 360.028 32.6097C359.383 31.9566 358.497 31.6309 357.372 31.6309C356.542 31.6309 355.846 31.8157 355.283 32.1858C355.158 32.2686 355.041 32.3619 354.929 32.4639L355.027 31.8429H352.466L350.387 44.1892L353.674 42.6728L354.132 39.97C354.682 40.4408 355.405 40.6794 356.305 40.6794C357.265 40.6794 358.094 40.4618 358.793 40.0262C359.406 39.6443 359.899 39.1209 360.272 38.4542C360.323 38.3609 360.373 38.2645 360.42 38.1656C360.805 37.361 360.997 36.4045 360.997 35.299C360.997 34.7682 360.927 34.2911 360.786 33.8648H360.786ZM357.62 36.9044C357.466 37.2572 357.244 37.5341 356.954 37.733C356.663 37.9332 356.322 38.034 355.932 38.034C355.337 38.034 354.886 37.8004 354.577 37.3357L354.93 35.2502C354.986 34.9233 355.192 34.6415 355.488 34.4876C355.76 34.3467 356.081 34.2763 356.447 34.2763C356.897 34.2763 357.245 34.3999 357.487 34.6464C357.731 34.893 357.852 35.2347 357.852 35.6704C357.852 36.14 357.775 36.5522 357.621 36.9044H357.62Z",
    fill: "#FF5D0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.326 37.3097L368.654 38.7743C367.671 40.0435 366.237 40.6794 364.354 40.6794C363.027 40.6794 361.987 40.3444 361.234 39.6734C361.007 39.4713 360.815 39.247 360.656 38.9992C360.781 38.8076 360.895 38.6031 360.998 38.3874C361.415 37.5161 361.626 36.4774 361.626 35.299C361.626 34.5686 361.503 33.921 361.258 33.3587C361.622 32.9187 362.064 32.5578 362.585 32.2748C363.372 31.8453 364.318 31.6309 365.42 31.6309C367.304 31.6309 368.66 32.336 369.49 33.7473L366.7 35.105C366.534 34.8819 366.338 34.6878 366.113 34.5229C365.888 34.3579 365.592 34.2763 365.224 34.2763C364.833 34.2763 364.486 34.3727 364.184 34.568C363.882 34.762 363.651 35.0345 363.491 35.3874C363.331 35.7408 363.251 36.153 363.251 36.6226C363.251 37.0922 363.382 37.416 363.642 37.6626C363.904 37.9091 364.265 38.034 364.727 38.034C365.082 38.034 365.387 37.9635 365.642 37.8214C365.896 37.6805 366.125 37.5106 366.326 37.3104V37.3097Z",
    fill: "#0A0A0A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M373.528 32.239C373.406 32.3255 373.292 32.4237 373.182 32.53L373.291 31.8423H370.701L369.262 40.4674H372.301L373.028 36.1048C373.185 35.168 373.99 34.4586 374.946 34.4524C374.953 34.4524 374.96 34.4524 374.967 34.4524C375.074 34.4524 375.183 34.4586 375.296 34.4703C375.409 34.4821 375.703 34.5538 375.8 34.605L376.301 31.7193C376.111 31.6606 375.886 31.6309 375.625 31.6309C374.796 31.6309 374.096 31.8336 373.528 32.2396V32.239Z",
    fill: "#0A0A0A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M382.05 36.6424C381.917 37.4266 381.245 38.0266 380.443 38.0322C380.438 38.0322 380.433 38.0322 380.427 38.0322C380.012 38.0322 379.713 37.9234 379.53 37.7059C379.346 37.4884 379.29 37.1739 379.361 36.7623L380.197 31.8411H377.157L376.286 36.9384C376.084 38.1378 376.251 39.061 376.784 39.7074C377.317 40.3544 378.17 40.6776 379.343 40.6776C380.419 40.6776 381.292 40.3785 381.965 39.7834L381.893 40.4656H384.444L385.902 31.8405H382.862L382.05 36.6418V36.6424Z",
    fill: "#0A0A0A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M388.917 28.0953C388.361 28.0953 387.919 28.2603 387.592 28.5903C387.265 28.9203 387.102 29.3559 387.102 29.8966C387.102 30.3187 387.224 30.6511 387.47 30.8946C387.715 31.1381 388.05 31.2598 388.475 31.2598C389.02 31.2598 389.458 31.0973 389.792 30.7729C390.124 30.4484 390.29 30.0103 390.29 29.4585C390.29 29.0476 390.165 28.7176 389.914 28.4686C389.663 28.2202 389.331 28.0953 388.917 28.0953Z",
    fill: "#0A0A0A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M385.312 40.4661H388.352L389.559 33.3258C389.69 32.5491 389.087 31.8409 388.293 31.8409H388.285C387.41 31.8409 386.664 32.4675 386.52 33.3228L385.313 40.4661H385.312Z",
    fill: "#0A0A0A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M394.656 34.3995H396.928L397.354 31.8419H395.089L395.651 28.6138L392.345 30.1308L392.046 31.8419H390.688L390.262 34.3995H391.622L391.186 37.0276C390.984 38.2035 391.15 39.1063 391.683 39.7354C392.216 40.3644 393.069 40.679 394.243 40.679C395.06 40.679 395.765 40.5733 396.358 40.3613L396.073 37.9273C395.942 37.9508 395.798 37.9743 395.638 37.9977C395.478 38.0212 395.309 38.033 395.131 38.033C394.776 38.033 394.521 37.9421 394.367 37.7598C394.213 37.5775 394.165 37.3044 394.225 36.9398L394.655 34.4001L394.656 34.3995Z",
    fill: "#0A0A0A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M468.872 1.48999H259.1C248.538 1.48999 239.988 10.0398 239.988 20.6013V365.259H487.983V20.6013C487.983 10.0398 479.433 1.48999 468.872 1.48999Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M333.18 89.4523H460.421",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M332.93 111.078H396.55",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M332.93 148.345H460.171",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M332.93 169.971H396.55",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M332.93 207.239H460.171",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.93 228.865H396.55",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.93 266.131H460.171",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M332.93 287.757H396.55",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M301.145 118.924H279.066C275.042 118.924 271.773 115.655 271.773 111.632V89.553C271.773 85.5296 275.042 82.2606 279.066 82.2606H301.145C305.168 82.2606 308.437 85.5296 308.437 89.553V111.632C308.437 115.705 305.168 118.924 301.145 118.924Z",
    fill: "#FF5D0E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M301.145 177.465H279.066C275.042 177.465 271.773 174.196 271.773 170.173V148.094C271.773 144.071 275.042 140.802 279.066 140.802H301.145C305.168 140.802 308.437 144.071 308.437 148.094V170.173C308.437 174.196 305.168 177.465 301.145 177.465Z",
    fill: "#FF5D0E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5312 86.6863C103.193 77.8347 109.933 64.5574 109.933 49.6204C109.933 23.0657 88.4072 1.48999 61.8022 1.48999C35.1973 1.48999 13.6719 23.0154 13.6719 49.6204C13.6719 76.2253 35.1973 97.7507 61.8022 97.7507C67.8374 97.7507 73.6714 96.6443 79.0024 94.5823C95.0459 106.954 107.368 103.534 107.368 103.534C99.7231 98.0525 95.1465 91.5647 92.5312 86.6863Z",
    fill: "#0A0A0A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2393 44.6412H41.1323C37.9639 44.6412 35.4492 42.0763 35.4492 38.9581V36.2423C35.4492 33.0739 38.0142 30.5592 41.1323 30.5592H85.2896C88.458 30.5592 90.9727 33.1241 90.9727 36.2423V38.9581C90.9224 42.1266 88.4077 44.6412 85.2393 44.6412Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7642 67.1224H41.1323C37.9639 67.1224 35.4492 64.5575 35.4492 61.4393V58.7235C35.4492 55.555 38.0142 53.0404 41.1323 53.0404H63.7642C66.9326 53.0404 69.4473 55.6053 69.4473 58.7235V61.4393C69.4473 64.5575 66.8823 67.1224 63.7642 67.1224Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M294.757 338.302L285.855 359.526V365.51H392.929V358.972C392.929 352.283 388.202 346.6 381.613 345.343L344.095 338.302H294.757Z",
    fill: "#FF5D0E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.855 359.526V365.511H392.929V358.973C392.929 358.922 392.929 358.922 392.929 358.872H286.157L285.855 359.526Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M318.044 232.637C335.765 232.637 350.131 218.271 350.131 200.55C350.131 182.829 335.765 168.463 318.044 168.463C300.323 168.463 285.957 182.829 285.957 200.55C285.957 218.271 300.323 232.637 318.044 232.637Z",
    fill: "#9F99AA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M296.821 176.51C296.821 176.51 262.722 208.597 259.453 221.522C256.184 234.397 208.758 309.384 208.758 309.384V357.665H259.906L291.942 307.422V338.252H350.182L349.98 196.828L296.821 176.51Z",
    fill: "#9F99AA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1533 363.398C62.8744 363.398 77.2402 349.033 77.2402 331.311C77.2402 313.59 62.8744 299.224 45.1533 299.224C27.4322 299.224 13.0664 313.59 13.0664 331.311C13.0664 349.033 27.4322 363.398 45.1533 363.398Z",
    fill: "#9F99AA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4453 300.683C35.4453 300.683 57.3228 290.121 102.888 277.095L222.183 255.369V363.448H45.1519L35.4453 300.683Z",
    fill: "#9F99AA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.234 318.587L237.121 319.744C237.121 319.744 277.607 312.049 278.311 327.892C278.512 332.317 278.361 346.953 277.003 351.831C272.98 366.315 258.445 366.165 243.458 365.008L222.234 363.398V318.587Z",
    fill: "#FF5D0E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M229.225 319.794C229.225 319.794 230.181 319.593 231.74 319.392L222.234 318.638V319.241L229.225 319.794Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M278.26 327.891C277.857 318.788 264.278 317.481 252.812 317.984C261.814 318.436 270.012 320.85 270.313 327.891C270.515 332.317 270.364 346.953 269.006 351.831C266.24 361.789 258.495 364.806 249.09 365.36C261.915 365.913 273.381 364.454 276.902 351.831C278.31 347.003 278.461 332.317 278.26 327.891Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M109.176 131.648L158.865 120.433H191.757L234.456 131.749L227.465 280.666H115.865L109.176 131.648Z",
    fill: "#FF5D0E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.336 254.061C145.336 254.061 157.557 250.39 159.72 246.517C161.882 242.645 168.471 249.334 162.989 254.866C157.457 260.398 157.457 260.398 157.457 260.398L145.336 254.061Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M145.336 254.061C145.336 254.061 157.557 250.39 159.72 246.517C161.882 242.645 168.471 249.334 162.989 254.866C157.457 260.398 157.457 260.398 157.457 260.398L145.336 254.061Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M227.465 176.51C240.131 176.51 250.398 166.242 250.398 153.576C250.398 140.91 240.131 130.642 227.465 130.642C214.799 130.642 204.531 140.91 204.531 153.576C204.531 166.242 214.799 176.51 227.465 176.51Z",
    fill: "#FF5D0E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M115.863 176.51C128.529 176.51 138.797 166.242 138.797 153.576C138.797 140.91 128.529 130.642 115.863 130.642C103.197 130.642 92.9297 140.91 92.9297 153.576C92.9297 166.242 103.197 176.51 115.863 176.51Z",
    fill: "#FF5D0E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0503 142.059L65.0195 186.518L103.695 210.558L134.726 166.602L96.0503 142.059Z",
    fill: "#FF5D0E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0205 186.518L53.7046 202.712C40.2261 222.025 45.6074 248.68 65.5234 261.203L101.785 284.086C106.21 286.903 111.34 288.361 116.571 288.361H125.322L136.789 284.941L155.397 292.385C155.397 292.385 159.772 291.63 158.867 287.758C158.867 287.758 164.047 287.305 163.343 282.628C163.343 282.628 166.21 280.314 165.355 277.045C165.355 277.045 168.624 275.436 167.668 271.211C166.763 267.037 153.586 255.872 145.338 254.011L123.461 253.257L96.1519 221.924L103.646 210.457L65.0205 186.518Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0205 186.518L53.7046 202.712C40.2261 222.025 45.6074 248.68 65.5234 261.203L101.785 284.086C106.21 286.903 111.34 288.361 116.571 288.361H125.322L136.789 284.941L155.397 292.385C155.397 292.385 159.772 291.63 158.867 287.758C158.867 287.758 164.047 287.305 163.343 282.628C163.343 282.628 166.21 280.314 165.355 277.045C165.355 277.045 168.624 275.436 167.668 271.211C166.763 267.037 153.586 255.872 145.338 254.011L123.461 253.257L96.1519 221.924L103.646 210.457L65.0205 186.518Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M98.313 224.489L91.9258 217.348",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M158.865 287.808L150.114 279.711L137.742 273.575",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.989 283.583L153.835 273.173L140.508 266.182",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M165.355 277.096L158.213 268.998L145.188 260.951",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M248.64 145.328L270.618 196.878L228.322 208.144L205.539 160.315L248.64 145.328Z",
    fill: "#FF5D0E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M228.32 208.144L233.551 226.35H276.954V217.247L270.617 196.878L228.32 208.144Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M228.32 208.144L233.551 226.35H276.954V217.247L270.617 196.878L228.32 208.144Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M266.493 296.71L289.778 229.418C291.136 225.545 288.27 221.522 284.146 221.522H182.554C181.447 221.522 180.441 222.226 180.089 223.332L155.546 300.281H123.057C121.85 300.281 120.895 301.236 120.895 302.443C120.895 303.65 121.699 304.103 121.85 304.606H247.784C260.458 304.556 264.883 301.387 266.493 296.71Z",
    fill: "#0A0A0A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M155.898 299.275L180.039 223.282C180.391 222.226 181.347 221.522 182.403 221.522C184.113 221.522 185.32 223.182 184.767 224.791L159.67 301.991C159.167 303.55 157.759 304.556 156.15 304.556H123.057C121.85 304.556 120.895 303.6 120.895 302.393C120.895 301.186 121.85 300.23 123.057 300.23H154.49C155.194 300.281 155.748 299.878 155.898 299.275Z",
    fill: "#9F99AA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M182.454 221.522C181.348 221.522 180.392 222.226 180.09 223.282L155.95 299.275C155.749 299.878 155.195 300.281 154.592 300.281H123.159C121.952 300.281 120.996 301.236 120.996 302.443C120.996 303.65 121.952 304.606 123.159 304.606H223.191",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M221.23 264.774L226.109 273.827L234.86 264.774L229.328 255.419L221.23 264.774Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M291.941 219.259V317.933V338.302H350.181",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M180.694 146.938H170.334C163.092 146.938 157.258 141.104 157.258 133.861V93.1241H193.771V133.861C193.771 141.104 187.886 146.938 180.694 146.938Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M180.694 146.938H170.334C163.092 146.938 157.258 141.104 157.258 133.861V93.1241H193.771V133.861C193.771 141.104 187.886 146.938 180.694 146.938Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M192.46 62.2943C192.46 62.2943 218.713 88.2455 205.285 111.632C191.857 135.018 156.551 104.49 156.551 104.49C156.551 104.49 141.966 73.1073 148.806 62.2943C155.696 51.431 181.044 46.452 192.46 62.2943Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M156.602 104.49C156.602 104.49 142.017 73.1074 148.857 62.2944C155.696 51.4311 181.094 46.4521 192.511 62.2944C192.511 62.2944 218.764 88.2455 205.336 111.632C199.2 122.344 188.488 121.741 178.68 117.969",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M158.813 70.5422C158.813 70.5422 191.856 76.527 201.562 61.1374C211.269 45.7477 197.036 34.8844 173.046 38.3044C149.057 41.7243 140.809 43.736 137.087 56.5607C137.087 56.5607 124.514 52.839 126.827 65.1105C129.09 77.382 132.963 100.215 156.55 104.49L153.332 81.6569C153.382 81.6569 160.222 77.1305 158.813 70.5422Z",
    fill: "#0A0A0A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M158.813 70.5422C158.813 70.5422 191.856 76.527 201.562 61.1374C211.269 45.7477 197.036 34.8844 173.046 38.3044C149.057 41.7243 140.809 43.736 137.087 56.5607C137.087 56.5607 124.514 52.839 126.827 65.1105C129.09 77.382 132.963 100.215 156.55 104.49L153.332 81.6569C153.382 81.6569 160.222 77.1305 158.813 70.5422Z",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M158.262 84.2219C158.262 84.2219 144.582 75.3703 142.571 79.947C140.056 85.7307 143.124 93.3249 148.254 96.4934C153.836 99.9133 159.469 94.8337 159.469 94.8337L158.262 84.2219Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M158.262 84.2219C158.262 84.2219 144.582 75.3703 142.571 79.947C140.056 85.7307 143.124 93.3249 148.254 96.4934C153.836 99.9133 159.469 94.8337 159.469 94.8337",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M142.067 304.556H95.0938",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M222.234 363.449V304.556",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M148.203 87.5919C148.203 87.5919 150.567 90.0563 155.093 89.3019",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M183.31 83.6689C183.813 85.7812 183.259 87.7427 182.002 88.0444C180.795 88.3462 179.387 86.8374 178.884 84.7251C178.381 82.6128 178.934 80.6514 180.192 80.3496C181.399 80.0478 182.807 81.5566 183.31 83.6689Z",
    fill: "#0A0A0A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M199.853 79.9974C200.356 82.1097 199.802 84.0711 198.545 84.3729C197.338 84.6746 195.93 83.1658 195.427 81.0535C194.924 78.9412 195.477 76.9798 196.734 76.678C197.942 76.3763 199.35 77.8348 199.853 79.9974Z",
    fill: "#0A0A0A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M171.238 79.3435C171.238 79.3435 175.714 74.0627 183.51 75.1692",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M200.758 72.8057C200.758 72.8057 195.98 71.5484 192.762 72.8057",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M190.853 84.2217C192.563 85.7808 194.374 87.2393 195.983 88.8989C196.586 89.5527 197.29 90.3071 197.492 91.2124C197.643 92.0171 197.14 92.7715 196.687 93.375C196.285 93.9282 196.184 94.6323 196.687 95.1352C197.14 95.5879 198.045 95.6885 198.447 95.1352C199.252 94.0791 200.006 92.9727 200.057 91.5645C200.057 90.2065 199.353 88.9995 198.548 87.9937C197.793 87.0381 196.838 86.1831 195.882 85.3784C194.826 84.4228 193.72 83.4673 192.664 82.5117C192.161 82.0591 191.406 82.0088 190.903 82.5117C190.4 82.9141 190.35 83.769 190.853 84.2217Z",
    fill: "#0A0A0A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M186.728 101.271C188.689 104.188 191.656 106.451 195.227 106.703C195.881 106.753 196.535 106.099 196.485 105.446C196.434 104.741 195.931 104.238 195.227 104.188C195.127 104.188 195.076 104.188 194.976 104.188C194.926 104.188 194.674 104.138 194.926 104.188C194.775 104.138 194.624 104.138 194.473 104.088C194.121 104.037 193.819 103.937 193.517 103.836C193.366 103.786 193.165 103.736 193.014 103.635C193.165 103.685 193.065 103.635 192.964 103.635C192.863 103.585 192.813 103.534 192.713 103.534C192.411 103.384 192.109 103.182 191.807 103.031C191.656 102.931 191.506 102.83 191.405 102.73C191.405 102.73 191.154 102.529 191.254 102.629C191.355 102.73 191.103 102.529 191.103 102.529C190.801 102.277 190.55 102.026 190.299 101.774C189.645 101.12 189.343 100.768 188.89 100.064C188.538 99.511 187.784 99.2092 187.18 99.6115C186.627 99.863 186.325 100.668 186.728 101.271Z",
    fill: "#0A0A0A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0195 186.518L78.3975 167.356",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M103.695 210.558L120.996 186.015",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M228.319 208.144L218.914 188.379",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M270.617 196.878L263.777 180.785",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39844 365.511H499.601",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M232.228 104.881L228.316 100.969L224.405 104.881L228.316 108.792L232.228 104.881Z",
    fill: "#FF5D0E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M283.488 44.1235L276.98 37.6157L270.473 44.1235L276.98 50.6314L283.488 44.1235Z",
    fill: "#FF5D0E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M209.008 15.7002L200.758 7.44977L192.507 15.7002L200.758 23.9506L209.008 15.7002Z",
    fill: "#FF5D0E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M280.574 95.2864L289.375 104.088L311.253 82.2102",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M280.574 155.688L289.375 164.54L311.253 142.663",
    stroke: "#0A0A0A",
    strokeWidth: 2.51465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourth);
export default __webpack_public_path__ + "static/media/fourth.9f51900c838a331960cf332f09d3f535.svg";
export { ForwardRef as ReactComponent };